

















































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import { Iutente, newUtenteServer } from '../plugins/utils/utentesUtils';
import { conection } from "@/plugins/utils/conectionUtils";
import { Icartao } from '../plugins/utils/cartaoUtils';
import { checkTratamentoAux, Iconsulta, Tratamentos } from '../plugins/utils/consultaUtils';
import { Imarcacao, diasSemana, DiaSemanaObject, marcacaoPresenca, retirarMarcacoesMapa } from '../plugins/utils/marcacaoUtils';
import { timestampStringToDate, nl2br, dateStringToDateDate, pad, checkRecepcao, checkDoc, checkTerapeuta } from '../plugins/utils/utils';


interface PresencaConsulta {
  id: number;
  id_consulta: number;
  id_marcacao: number;
  data: string;
  timestamp: string;
  id_terapeuta: number | null;
  terapeuta: string | null;
  hora: string | null;
}
interface MarcacaoConsulta extends Imarcacao{
  terapeuta: string;
}
interface ConsultaCartao extends Iconsulta{
  marcacoes: MarcacaoConsulta[];
  presencas: PresencaConsulta[];
  flag_activo: boolean;
}
interface CartaoUtente extends Icartao{
  seguro: string;
  consultas: ConsultaCartao[];
}
type responseUtente = {
  dados: Iutente;
  cartoes: CartaoUtente[];
}
type resp_idconsulta = {
  id_consulta: number;
}
type itemPresecMarc = {
  terapeuta: string;
  dia_semana: DiaSemanaObject;
  data: string;
  hora: string;
  status: number;
  id: number;
  passed: boolean;
}

@Component({
  components: {
    TitleArea
  }
})
export default class UtenteInfo extends Vue {
  primaryColor = this.$vuetify.theme.themes.light.primary;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: Array<any> = [
    {
      text: "Data",
      align: 'start',
      sortable: false,
      value: 'data',
    },
    {
      text: "Dia Semana",
      align: 'start',
      sortable: false,
      value: 'dia_semana',
    },
    {
      text: "Horas",
      align: 'start',
      sortable: false,
      value: 'horas',
    },
    {
      text: "Terapeuta",
      align: 'start',
      sortable: false,
      value: 'terapeuta',
    },
    {
      text: "Presença",
      align: 'center',
      sortable: false,
      value: 'status',
    },
  ];

  getDateFormated(timestamp: string): string{
    const date = timestampStringToDate(timestamp);
    // console.log(date);
    return date.getDate()+"/"+date.getMonth()+"/"+date.getFullYear();
  }

  getTextFormated(string: string): string{
    return nl2br(string, false);
  }

  tabs = null;

  utenteInfo: responseUtente | null = null; 
  created(){
    this.$store.commit("setLoading", true);
    if(this.$route.params.id_utente){
      const id_utente = parseInt(this.$route.params.id_utente);
      this.getUtente(id_utente);
    }
    else {
      this.idErrorHandler();
    }
  }

  getUtente(id: number): void{
    conection(
      "getUtente.php",
      {id: id}, 
      (resp: responseUtente) => {
        // console.log(resp);
        this.utenteInfo = resp;
        this.$store.commit("setLoading", false);
      }, 
      () => {
        this.idErrorHandler();
      }
    );
  }

  
  createSlots(consulta: ConsultaCartao): itemPresecMarc[]{
    
    // console.log(consulta);
    const new_presencas: itemPresecMarc[] = [];

    // GET DIAS DE MARCAÇÕES
    const todayDate = new Date();
    let dataIni = dateStringToDateDate(consulta.data);
    let today = dataIni.getDay();
    
    if(today < 1) today = 1;
    else if(today > 5) today = 5;
    const dayWeek = diasSemana[today-1];
    
    let firstDay: MarcacaoConsulta | null = null;
    let firstPresence = 0;

    let first_presenca_terapeuta = null;
    let first_presenca_hora = null;
    
    consulta.marcacoes.forEach(m => {
      if(m.activo == 1){
        consulta.flag_activo = true;
      }
      
      if(consulta.presencas.length > 0 &&  consulta.presencas[0].id_marcacao == m.id){
        firstDay = m;
        dataIni = dateStringToDateDate(consulta.presencas[0].data);
        firstPresence = 1;
        first_presenca_terapeuta = consulta.presencas[0].terapeuta;
        first_presenca_hora = consulta.presencas[0].hora;
      }
      else if(m.dia_semana == dayWeek.value && firstDay == null){
        firstDay = m;
      }
      
    });
    
    

    if(firstDay == null && consulta.marcacoes.length > 0){
      const nextDay =  dateStringToDateDate(consulta.data);
      nextDay.setDate(nextDay.getDate() + 1 );
      // console.log("vou para o ciclo infinito");
      while (firstDay == null) {
        if( !(nextDay.getDay() == 0 || nextDay.getDay() == 6) ){

          const dayWeekSearc = diasSemana[nextDay.getDay()-1];

          for (let index = 0; index < consulta.marcacoes.length; index++) {
            const m = consulta.marcacoes[index];
            if(m.dia_semana == dayWeekSearc.value){
              firstDay = m;
              // dataIni = nextDay;
              dataIni = new Date(nextDay.getTime());
              // j = index;
              index = consulta.marcacoes.length;
            }
          }

        }
        nextDay.setDate(nextDay.getDate() + 1 );
      }
    }
    
    
    if(firstDay != null){
      let i = 1;
      let flag_passed = false;
      if(dataIni < todayDate){
        flag_passed = true;
        i = 0;
      }

      const newItem: itemPresecMarc = {
        terapeuta: first_presenca_terapeuta ? first_presenca_terapeuta : firstDay.terapeuta,
        dia_semana: diasSemana[dataIni.getDay()-1],
        data: dataIni.getFullYear()+"-"+ pad(dataIni.getMonth()+1, 2) + "-" + pad(dataIni.getDate(), 2),
        hora: first_presenca_hora ? first_presenca_hora : firstDay.hora,
        status: firstPresence,
        id: firstDay.id as number,
        passed: flag_passed
      }
      if(
        !(!flag_passed && !consulta.flag_activo && !firstPresence) 
      ){
        new_presencas.push(newItem);
      }

      if(firstPresence){
        i=1;
      }

      

      let counter = 1;
      
      for (i; i < consulta.n_tratamentos; i++) {
        let flag_found = false;
        
        let limite = 0;
        while (!flag_found && counter < consulta.n_tratamentos && limite < 100) {
          dataIni.setDate(dataIni.getDate() + 1 );
          if( !(dataIni.getDay() == 0 || dataIni.getDay() == 6) ){

            const dayWeek = diasSemana[dataIni.getDay()-1];
            const dataBD = dataIni.getFullYear()+"-"+ pad(dataIni.getMonth()+1, 2) + "-" + pad(dataIni.getDate(), 2);
            let status = 0;
            let passed = false;
            for (let index = 0; index < consulta.marcacoes.length; index++) {
              const m = consulta.marcacoes[index];
              if(m.dia_semana == dayWeek.value){

                let p_terapeuta = null; 
                let hora = null;
                for (let indexP = 0; indexP < consulta.presencas.length; indexP++) {
                  const p = consulta.presencas[indexP];
                  if(p.id_marcacao == m.id && p.data == dataBD){
                    status = 1;
                    p_terapeuta = p.terapeuta;
                    hora = p.hora;
                    indexP = consulta.presencas.length;
                  }
                }

                if(dataIni < todayDate){
                  passed = true;
                  if(status == 0){
                    i = i -1;
                  }
                }

                  if(status){
                    first_presenca_terapeuta = p_terapeuta ? p_terapeuta : m.terapeuta;
                  }
                // if(m.activo){
                  const newItem: itemPresecMarc = {
                    terapeuta: p_terapeuta ? p_terapeuta : m.terapeuta,
                    dia_semana: dayWeek,
                    data: dataBD,
                    hora: hora ? hora : m.hora,
                    status: status,
                    id: m.id as number,
                    passed: passed
                  }
                  
                  
                  if( 
                    (passed && status) ||
                    (passed && !status && (first_presenca_terapeuta == m.terapeuta || first_presenca_terapeuta == null )) ||  
                    (!passed)
                  ){
                    
                    if(
                      !(!passed && !consulta.flag_activo && !status) 
                    ){
                      // new_presencas.push(newItem);
                      if(newItem.data > new_presencas[ new_presencas.length -1 ].data){
                        new_presencas.push(newItem);
                      }
                      else if(newItem.data == new_presencas[ new_presencas.length -1 ].data && newItem.status == 1 && new_presencas[ new_presencas.length -1 ].status == 0){
                        new_presencas[new_presencas.length -1] = newItem;
                      }
                      
                    }
                  }

                  // console.log("found", status);


                  if(status){
                    
                    counter = counter + 1;
                    // console.log("presente", counter);
                  }
  
  
                  flag_found = true;
                  index = consulta.marcacoes.length;
                // }

                // if()

              }
            }
            if(!status){
              for (let index = 0; index < consulta.presencas.length; index++) {
                const p = consulta.presencas[index];
                
                if(p.data == dataBD){
                  let newM: MarcacaoConsulta | null = null;
                  for (let indexP = 0; indexP < consulta.marcacoes.length; indexP++) {
                    const m = consulta.marcacoes[indexP];
                    if(p.id_marcacao == m.id && p.data == dataBD){
                      status = 1;
                      indexP = consulta.marcacoes.length;
                      newM = m
                    }
                  }
                  
                  if(newM != null){

                    if(dataIni < todayDate){
                      passed = true;
                      if(status == 0){
                        i = i -1;
                      }
                    }
                    if(status){
                      first_presenca_terapeuta = p.terapeuta ? p.terapeuta : newM.terapeuta;
                    }
                    
                    const newItem: itemPresecMarc = {
                      terapeuta: p.terapeuta ? p.terapeuta : newM.terapeuta,
                      dia_semana: dayWeek,
                      data: dataBD,
                      hora: p.hora ? p.hora : newM.hora,
                      status: status,
                      id: newM.id as number,
                      passed: passed
                    }
                    if( 
                      (passed && status) ||
                      (passed && !status && (first_presenca_terapeuta == newM.terapeuta || first_presenca_terapeuta == null )) || 
                      (!passed)
                    ){
                      if(
                        !(!passed && !consulta.flag_activo && !status) 
                      ){
                        // new_presencas.push(newItem);
                        if(newItem.data > new_presencas[ new_presencas.length -1 ].data){
                          new_presencas.push(newItem);
                        }
                        else if(newItem.data == new_presencas[ new_presencas.length -1 ].data && newItem.status == 1 && new_presencas[ new_presencas.length -1 ].status == 0){
                          new_presencas[new_presencas.length -1] = newItem;
                        }
                      }
                    }

                    // console.log("found", status);


                    if(status){
                      
                      counter = counter + 1;
                      // console.log("presente", counter);
                    }
    
    
                    flag_found = true;
                    index = consulta.presencas.length;
                  }

                  // if()

                }
              }

            }
            
          }
          limite++;
        }
        
      }  

      
    }

    
    return new_presencas;
  
  }

  dialogMarc = false;
  consultaMarc: ConsultaCartao | null = null;
  data_extra = "";
  menu2 = false;
  openMarcacaoExtra(consulta: ConsultaCartao) {
    this.consultaMarc = consulta;
    this.dialogMarc = true;
  }
  closeMarcacaoExtra() {
    this.consultaMarc = null;
    this.dialogMarc = false;
    this.data_extra = "";
  }
  marcarExtra(): void {
    if(
      this.consultaMarc && 
      this.consultaMarc.marcacoes &&
      this.consultaMarc.marcacoes.length > 0 && 
      this.consultaMarc.marcacoes[0].id && 
      this.data_extra != ""
    ) {
      const id_marc = this.consultaMarc.marcacoes[0].id;
      const status = 1;
      const data = this.data_extra;
      this.marcacaoPresenca({
        id: id_marc, 
        status: status, 
        data: data, 
        terapeuta: this.consultaMarc.marcacoes[0].terapeuta,
        dia_semana: diasSemana[0],
        hora: this.consultaMarc.marcacoes[0].hora,
        passed: true
      });
    }
  }
  
  flag_popup_retirar = false;
  remove_id_consulta: number | null = null;

  clearRemoveFlags(){
    this.flag_popup_retirar = false;
    this.remove_id_consulta = null;
  }
  // desactivarMarcacoes(consulta.id)
  desactivarMarcacoes(id_consulta: number): void{
    this.$store.commit("setLoading", true);
    retirarMarcacoesMapa(
      id_consulta,
      () => {
        const string_feedback = "Retirado do Mapa";
        this.$store.commit("setError", {flag: true, text: string_feedback, status: "success"});
        this.clearRemoveFlags()
        if(this.utenteInfo != null)
          this.getUtente(this.utenteInfo.dados.id );
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu ao retirar do mapa! Tente de novo", status: "error"});
        if(this.utenteInfo != null)
          this.getUtente(this.utenteInfo.dados.id );
        this.$store.commit("setLoading", false);
      }
    );
  }
  marcacaoPresenca(item: itemPresecMarc): void{
    this.$store.commit("setLoading", true);
    marcacaoPresenca(
      item.id,
      item.status,
      item.data,
      () => {
        let string_feedback = "Presença assinalada";
        if(item.status == 0) string_feedback = "Presença retirada"; 
        this.$store.commit("setError", {flag: true, text: string_feedback, status: "success"});
        if(this.utenteInfo != null)
          this.getUtente(this.utenteInfo.dados.id );
        
        this.closeMarcacaoExtra();
      },
      () => {
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro a assinalar/retirar a presença! Tente de novo", status: "error"});
        this.$store.commit("setLoading", false);
        item.status = item.status*(-1)+1;
      }
    );
  }

  get titleArea(): string{
    if(!this.utenteInfo) return "";
    else return this.utenteInfo.dados.nome;
  }

  idErrorHandler(): void{
    this.$store.commit("setLoading", false);
    this.$store.commit("setError", {flag: true, text: "Utente inválido", status: "error"});
    this.$router.push("/dashboard");
  }

  // EDITAR
  flag_editmode = false;
  save(): void {
    this.$store.commit("setError", {flag: false, text: "", status: "error"});
    if(this.utenteInfo && !this.utenteInfo.dados.nome) {
      this.$store.commit("setError", {flag: true, text: "Preencha o nome do utente!", status: "error"});
    }
    else{
      this.callServer();
    }
  }

  callServer(): void {
    if(this.utenteInfo){
      this.$store.commit("setLoading", true);
      newUtenteServer(
        {
          id: this.utenteInfo.dados.id,
          nome: this.utenteInfo.dados.nome,
          telefone: this.utenteInfo.dados.telefone as string,
          codigo: this.utenteInfo.dados.codigo as string,
          observacoes: this.utenteInfo.dados.observacoes as string,
        },
        () => {
          this.$store.commit("setError", {flag: true, text: "Alterações salvas com sucesso!", status: "success"});
          this.flag_editmode = false;
          this.$store.commit("setLoading",false);
        },
        () => {
          this.$store.commit("setError", {flag: true, text: "Ocorreu um erro ao guardar os dados no servidor...", status: "error"});
          this.$store.commit("setLoading",false);
        }
      );
    }

  }

  // MARCACOES SEM CONSULTA
  dialogNewTrat = false;
  idCartaoSel: number | null = null;
  nTratamentosNew = 0;
  openNewTrat(cartao: CartaoUtente){
    this.idCartaoSel = cartao.id;
    this.nTratamentosNew = cartao.consultas[0] ? cartao.consultas[0].n_tratamentos : 0;
    this.dialogNewTrat = true;
  }
  closeTratamentos(){
    this.idCartaoSel = null; 
    this.nTratamentosNew = 0;
    this.dialogNewTrat = false;
  }
  marcarTratamentos(){
    this.$store.commit("setLoading", true);
    conection(
      "saveFakeConsulta.php",
      {id_cartao: this.idCartaoSel, n_tratamentos: this.nTratamentosNew},
      (resp: resp_idconsulta) => {
        // console.log(resp);
        this.$router.push("/utentes/marcacoes/editar/"+resp.id_consulta);
        this.$store.commit("setLoading", false);
        this.closeTratamentos();
      }, 
      () => {
        this.$store.commit("setLoading", false);
        this.$store.commit("setError", {flag: true, text: "Ocorreu um erro ao inserir novas marcações. Tente de novo", status: "error"});
        this.closeTratamentos();
      })
  }

  get checkRecepcao(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel != undefined)
      return checkRecepcao(this.$store.getters.userData.nivel);
    else
      return false;
  }
  get checkDoc(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel != undefined){
      return checkDoc(this.$store.getters.userData.nivel);
    }
    else{
      return false;
    }
  }

  get checkTerapeuta(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel != undefined){
      return checkTerapeuta(this.$store.getters.userData.nivel);
    }
    else{
      return false;
    }
  }

  tratamentosDivided(tratamento: string): Tratamentos | null{
    if(tratamento){
      return checkTratamentoAux(tratamento, this.$store.getters.separatorAux);
    } else {
      return null;
    }
  }
  
}
